import { ChartNoAxesColumnIncreasing, Rocket, ShieldCheck } from "lucide-react";
import howItWorksImage from "@/images/site/how-it-works.jpg";
import Container from "../site/Container";
import CtaBand from "../site/CtaBand";
import FeatureStrip, { Feature } from "../site/FeatureStrip";
import PageHeader from "../site/PageHeader";

const steps = [
  {
    title: "Apply",
    text: "Tell us about your situation and the home you want. We’ll assess your eligibility.",
  },
  {
    title: "We provide a Boost",
    text: "We contribute an additional amount to increase your buying budget, on top of your deposit and loan.",
  },
  {
    title: "Buy your home",
    text: "You purchase the property with a larger buying budget and become the homeowner sooner.",
  },
  {
    title: "Refinance and repay",
    text: "When your home’s value and your situation allow, you refinance to a standard mortgage and repay the Boost, typically within 3–5 years.",
  },
];

const benefits: Feature[] = [
  { icon: Rocket, title: "Buy sooner", text: "Get into your home earlier." },
  { icon: ChartNoAxesColumnIncreasing, title: "A bigger buying budget", text: "Access more of the homes you want." },
  { icon: ShieldCheck, title: "Simple and transparent", text: "Clear terms, with repayment typically via a refinance." },
];

const HowItWorks = () => {
  return (
    <>
      <section className="py-14 sm:py-20">
        <Container>
          <PageHeader
            eyebrow="How BuySooner Boost works"
            title={
              <>
                A simple way to buy sooner, <br className="hidden sm:block" />
                with a bigger buying budget.
              </>
            }
          >
            <p>
              BuySooner Boost gives you more buying power today, so you can purchase the home you want now and repay
              the Boost later, typically with a refinance.
            </p>
          </PageHeader>

          <div className="mt-12 grid gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-16">
            <ol>
              {steps.map((step, index) => (
                <li key={step.title} className="relative flex gap-5 pb-10 last:pb-0">
                  {index < steps.length - 1 && (
                    <span
                      aria-hidden
                      className="absolute top-12 bottom-2 left-5 w-1 -translate-x-1/2 bg-[radial-gradient(circle,var(--color-brand)_1.5px,transparent_2px)] bg-[length:4px_12px] bg-repeat-y"
                    />
                  )}
                  <span
                    aria-hidden
                    className="grid size-10 shrink-0 place-items-center rounded-full bg-brand font-semibold text-white"
                  >
                    {index + 1}
                  </span>
                  <div className="pt-1.5">
                    <h3 className="text-lg font-semibold text-navy">{step.title}</h3>
                    <p className="mt-1.5 leading-relaxed text-slate-600">{step.text}</p>
                  </div>
                </li>
              ))}
            </ol>
            <div className="relative min-h-80 overflow-hidden rounded-2xl">
              <img
                src={howItWorksImage}
                alt="A bright dining room overlooking the harbour"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
          </div>

          <FeatureStrip features={benefits} className="mt-14" />
        </Container>
      </section>

      <CtaBand />
    </>
  );
};

export default HowItWorks;
